<div class="w-10 h-10 rounded-lg  flex items-center justify-center flex-shrink-0">
  <i [class]="getFileIcon(document().name)" class="text-xl"></i>
</div>

<div class="flex-1 min-w-0">
  <p
    (click)="preview()"
    class="text-sm font-medium text-surface-800 truncate {{ previewMimeType() ? 'cursor-pointer hover:underline' : '' }}">
    {{ document().name }}
  </p>
  <p class="text-xs text-surface-400 mt-0.5">
    {{ document().createdAt | date:'dd/MM/yyyy HH:mm' }}
    @if (document().createdBy) {
      · {{ document().createdBy?.fullName }}
    }
  </p>
</div>

<div class="flex items-center opacity-0 group-hover:opacity-100 transition-opacity">
  <elcia-button
    (onClick)="onDownload.emit()"
    [icon]="'download'"
    [size]="'small'"
    [variant]="'text'"
  />
  <elcia-button
    (onClick)="onDelete.emit()"
    [icon]="'delete'"
    [severity]="'danger'"
    [size]="'small'"
    [variant]="'text'"
  />
</div>

